<template>
    <div style="margin:20px">
        <!--
        <v-card class="mb-5">
            <v-toolbar dense color="primary" dark align="center">
                <v-row>
                    <v-col cols="5" align="left">
                        <v-toolbar-title>Gestione Aggiornamenti QuickConnext</v-toolbar-title>
                    </v-col>
                </v-row>
            </v-toolbar>
            <v-container>
                <v-tabs v-model="ui.tabs" centered>
                    <v-tab>Core</v-tab>
                    <v-tab>Moduli</v-tab>
                </v-tabs>
                <v-divider />
                <v-tabs-items v-model="ui.tabs">
                    <v-tab-item>
                        <GestioneCore/>
                    </v-tab-item>
                    <v-tab-item>
                        
                    </v-tab-item>
                </v-tabs-items>
            </v-container>
        </v-card>
        -->
        <GestioneModuli />
    </div>
</template>
<script>
//import GestioneCore from "./GestioneCore.vue";
import GestioneModuli from './Gestione Moduli/GestioneModuliQuickConnext.vue';
export default {
  name: "GestioneAggiornamentiQuickconnext",
  components: {
    //GestioneCore,
    GestioneModuli
  },
  data() {
    return {
      ui: {
        tabs: 0,
      },
    };
  },
  methods: {
    refresh() {},
  },
};
</script>